import { useTranslation } from '../../../hooks/useTranslation';
import { stripHtml } from '../../../components/StripHtml';

const RoleGroupTooltip = ({ roles = [], groupName, langMap, processDefaultlanguage_id }) => {
  const langKey = langMap?.[processDefaultlanguage_id] || 'EN';

  const t = useTranslation();
  return (
    <div className="role_dropdowm_container" style={styles.container}>
      <style>{`
                .tooltip-body ::-webkit-scrollbar { width:4px; }
                .tooltip-body ::-webkit-scrollbar-track { background: transparent;width:0px;}
                .tooltip-body ::-webkit-scrollbar-thumb { background: #002060;}
                .role_dropdowm_container {
                z-index: 999999999999 !important;
                }
                .role_dropdowm {
                z-index: 999999999999 !important;
                }
            `}</style>
      <div className="role_dropdowm" style={styles.tooltip}>
        <div style={styles.tooltipHeader}>
          <span style={{ fontWeight: '500', fontSize: '13px' }}>
            {groupName || t('role_group_breakdown')}
          </span>
        </div>

        <div
          className="nowheel nopan tooltip-body role_sub_dropdowm"
          style={styles.tooltipBody}
          onWheel={(e) => e.stopPropagation()}
        >
          {roles.length > 0 ? (
            <div className="scroll_bar_ul">
              <ul style={styles.roleList} className="role_dropdown_list">
                {roles.map((role, idx) => {
                  const displayName = stripHtml(role.translations?.[langKey] || role.name || '');

                  return (
                    <li className="role_items" key={idx} style={styles.roleItem}>
                      <span style={styles.roleName}>{displayName}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : (
            <div style={styles.emptyText}>{t('no_roles_assigned_to_this_group')}</div>
          )}
        </div>
      </div>
    </div>
  );
};

/* ✅ Tooltip-specific styles yahin rahenge */
const styles = {
  container: {
    display: 'inline-block',
    pointerEvents: 'auto',
    fontFamily: "'Poppins', sans-serif",
    // zIndex: 2000000,
    position: 'relative',
  },
  tooltip: {
    backgroundColor: '#ffffff',
    color: '#002060',
    minWidth: '240px',
    maxWidth: '300px',
    borderRadius: '0px',
    // zIndex: 2000000,
    boxShadow: '0 4px 10px rgba(0,32,96,0.35)',
    border: '1px solid #1A192B',
  },
  tooltipHeader: {
    backgroundColor: '#fff',
    padding: '10px 14px 0',
  },
  tooltipBody: {
    padding: '10px 15px 15px',
  },
  roleList: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  roleItem: {
    padding: '10px 14px',
    display: 'flex',
    flexDirection: 'column',
  },
  roleName: {
    fontSize: '12px',
    fontWeight: '300',
  },
  roleOwner: {
    fontSize: '11px',
    color: '#7A8699',
    marginTop: '3px',
  },
  emptyText: {
    padding: '5px',
    fontStyle: 'italic',
    opacity: 0.7,
    fontSize: '12px',
  },
};
export default RoleGroupTooltip;
